import { FC } from 'react';
import missionIcon from 'images/missionIcon.svg';

const MissionIcon: FC = (props): JSX.Element => {
  return <img src={missionIcon} alt="mission-icon" />;
};
export default MissionIcon;
